module.exports = __webpack_public_path__ + "img/1.870c1759.jpg";